  <ng-template #Modal let-data let-ref="modalRef" >
    <nb-card class="staffInfoTemplate " style="max-width: 800px">
      <nb-card-header style="display: flex; justify-content: space-between; align-items: center;">
        歷程紀錄
      </nb-card-header>

      <nb-card-body>
        
        <div class="row">
          
          <div class="w-100 mt-2">
            <table class="table table-bordered table-striped">
              <thead>
                <tr>
                  <th>操作人員</th>
                  <th>變更狀態</th>
                  <th>更新時間</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let status of statusHistory; let index = index">
                  <td style="vertical-align: middle;">
                    {{status.CreateBy}}
                  </td>
                  <td style="vertical-align: middle;">
                    {{status.statusName}}
                  </td>
                  <td style="vertical-align: middle;">
                    {{status.CreateDate}}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </nb-card-body>
      <nb-card-footer>
        <div class="">
          <button nbButton (click)="onClose()">關閉</button>
        </div>
      </nb-card-footer>
    </nb-card>
  </ng-template>